import React, {useEffect, useState} from "react";
import Modal from 'react-bootstrap/Modal';
import $ from "jquery";
import { Helmet } from "react-helmet";

import 'instantsearch.css/themes/reset.css';
import 'instantsearch.css/themes/satellite.css';
import PropertyBtn from "gatsby-theme-starberry-lomondgroup/src/components/PropertyBtn/PropertyBtn";
import NoStats from "gatsby-theme-starberry-lomondgroup/src/components/SalesCard/NoProperties";
import SearchResultsPagination from "gatsby-theme-starberry-lomondgroup/src/components/SalesCard/SearchResultsPagination";
import "gatsby-theme-starberry-lomondgroup/src/components/SalesCard/SalesCard.scss"

import { propertyDetailUrl } from "gatsby-theme-starberry-lomondgroup/src/common/utils/property_utils";

import ListView from "./ListView"
import ListView_Newhomes from "./ListView_Newhomes"

import {capitalize} from "lodash";
import { graphql, useStaticQuery } from "gatsby";

// const CustomPagination = ({ currentRefinement, nbPages, refine, createURL, pagenumber }) => {

//     useEffect(() => {
//       if (parseInt(nbPages) <= parseInt(pagenumber)) {
//         $('.page-next').attr('disabled', true);
//       }
//       else {
//         $('.page-next').attr('disabled', false);
//       }
  
//       if (parseInt(pagenumber) == 1) {
//         $('.page-back').attr('disabled', true);
//       }
//       else {
//         $('.page-back').attr('disabled', false);
//       }
//     }, [pagenumber])
  
  
//     // Pagination select box
//     const paginationselect = () => {
//       var page_val = document.getElementById('pagination-select').value
//       navigate(createURL(page_val))
//       refine(page_val);
  
//       if (window) {
//         window.scroll({
//           top: -100,
//           behavior: 'smooth'
//         });
//       }
//     }
//     // Pagination select box
  
//     // Next Pagination Button
//     const nextpage = () => {
//       var next_page_number = parseInt(pagenumber) + 1
//       navigate(createURL(next_page_number))
//       refine(next_page_number);
  
//       if (window) {
//         window.scroll({
//           top: -100,
//           behavior: 'smooth'
//         });
//       }
//     }
//     // Next Pagination Button
  
//     // Previous Pagination Button
//     const prevpage = () => {
//       var prev_page_number = parseInt(pagenumber) - 1
//       navigate(createURL(prev_page_number))
//       refine(prev_page_number);
  
//       if (window) {
//         window.scroll({
//           top: -100,
//           behavior: 'smooth'
//         });
//       }
//     }
//     // Previous Pagination Button
  
//     return (
//       <Row className="custom_pagination">
//         <Col className="col-2">
//           <button className="page-back" onClick={() => prevpage()}><i className="pagination-left"></i></button>
//         </Col>
//         <Col className="text-center col-8 pagination_dropdown">
//           Page:<select id="pagination-select" className="pagination-select" onChange={() => paginationselect()}>
//             {new Array(nbPages).fill(null).map((_, index) => {
//               const page = index + 1;
//               return (
//                 <option value={page}
//                   selected={pagenumber == page ? "selected" : ""}
//                 >
//                   {page}
//                 </option>
//               );
//             })}
//           </select>of {nbPages}
//         </Col>
//         <Col className="col-2 text-right">
//           <button className="page-next" onClick={() => nextpage()}><i className="pagination-right"></i></button>
//         </Col>
//       </Row>
//     )
// }
  
//const CustomPaginationRender = connectPagination(CustomPagination);

const InfiniteHits = ({
  algoliadata,
  location_path,
  page_url_data,
    no_properties,
    isGridView,
    search_type,
    window_wdth,
    userObjects,
    collections_property,
    location_state,
    show_pppw,
    student_property
}) => {

    const data =useStaticQuery(graphql`
    query OfficeContactQuerySalesCardCustom{
        glstrapi {
            offices {
                office_crm_id
                mobile
                email
                letting_info {
                    mobile
                    longitude
                    latitude
                    email
                    address
                }
            }
        }
    }`)

    var offices = data.glstrapi?.offices;

    //console.log("offices ==>", offices)

  const [isBackButtonClicked, setBackbuttonPress] = useState(false)
  const [modalShow, setModalShow] = React.useState(false);
  const [book_a_viewing_link, setViewingLink] = React.useState("");


    const whislist_item = typeof window !== 'undefined' && (localStorage.getItem('whislist_data') ? JSON.parse(localStorage.getItem('whislist_data')) : "");

    const [add_enquiry, setBulkEnquiry] = useState(whislist_item?.length > 0 ? whislist_item : []);


    useEffect(() => {
      localStorage.setItem('whislist_data', JSON.stringify(add_enquiry));
    }, [add_enquiry])

    useEffect(() => {
        setTimeout(()=>{
            $("a[href='#']").attr("href","javascript:;");
        },500)
    },[])


    //console.log("hits ==>", hits);

    var url_main = typeof window !== 'undefined' ? window.location.pathname : ''
    var page = url_main.split("/").filter(c => c.includes("page-")).length > 0 ? url_main.split("/").filter(c => c.includes("page-"))[0].split("page-").map(c => c)[1] : 1
  
    //console.log("no_properties ==>", no_properties);

    var itemListElement = [];
    if (algoliadata?.hits?.length > 0) {
        (algoliadata?.hits).map((val, key) => {
            var department = val?.department ? val.department : "residential"

            var property_url = propertyDetailUrl(department, val.search_type, val.status, val.slug, val.objectID || val.id);

            itemListElement.push(
                {
                    "@type": "ListItem",
                    "position": key + 1,
                    "url": process.env.GATSBY_SITE_URL+""+property_url,
                    "name": capitalize(val.title) +" in "+val.display_address
                }
            )
        })
    }

    var ldJson = `{
      "@context":"https://schema.org",
      "@type":"ItemList",
      "itemListElement":${JSON.stringify(itemListElement)}
    }`

    return (
        <>

            {/* <script 
              type="application/ld+json" 
              dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }}                
            /> */}

            <Helmet>
              <script  type="application/ld+json">{ldJson}</script>
            </Helmet>


            <section className="sales-section">

                <div className="sales-wrapper">
                    {algoliadata?.hits?.length > 0 ?
                        (algoliadata?.hits.map((item, index) => {
                        return (
                            <>
                                {search_type === "newdevelopments" ? 
                                    <ListView_Newhomes item={item} key={index} search_type={search_type} userObjects={userObjects} collections_property={collections_property} img_type={algoliadata?.realuser ? "no_property" : "property_list"} student_property={student_property} offices={offices} setModalShow={setModalShow} setViewingLink={setViewingLink} />
                                :
                                    <ListView item={item} key={index} isGridView={isGridView} userObjects={userObjects} collections_property={collections_property} show_pppw={show_pppw} add_enquiry={add_enquiry} setBulkEnquiry={setBulkEnquiry} img_type={algoliadata?.realuser ? "no_property" : "property_list"} student_property={student_property} offices={offices} setModalShow={setModalShow} setViewingLink={setViewingLink} />
                                }
                                

                                {algoliadata?.hits?.length > 4 && (index + 1) % 4 === 0 ? <PropertyBtn /> : ''}
                            </>
                        )
                        })) : (
                            <NoStats properties={no_properties} img_type="no_property" userObjects={userObjects} search_type={search_type} collections_property={collections_property}/>
                        )
                    }
                    
                </div>

                {/* {window_wdth < 768 ?
                    (hits?.length > 0 && <CustomPaginationRender pagenumber={parseInt(page)} />)
                    :
                    <Pagination showFirst={false} showPrevious={true} showNext={true} showLast={false} padding={5}  />
                } */}
                
                {(algoliadata?.total > algoliadata?.hitsPerPage) ? <SearchResultsPagination location_path={location_path} page_url_data={page_url_data} total={algoliadata?.total} current_page_number={algoliadata?.current_page_number} hitsPerPage={algoliadata?.hitsPerPage} nbPages={algoliadata?.number_of_pages} location_state={location_state} /> : <div className="empty-space-search"></div>}



                <Modal
                    show={modalShow}
                    onHide={() => {setModalShow(false); setViewingLink("")}}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter" className="book_a_viewing_ttl">
                            Book a Viewing
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="team_content col-md-12 col-lg-18 p-0">
                            <iframe src={book_a_viewing_link} height="600" width={"100%"} className="book_a_viewing" />
                        </div>
                    </Modal.Body>
                </Modal>


            </section>
        </>
    );
};
export default InfiniteHits;